import { render, staticRenderFns } from "./notFoundPage.vue?vue&type=template&id=2230e133&scoped=true"
var script = {}
import style0 from "./notFoundPage.vue?vue&type=style&index=0&id=2230e133&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2230e133",
  null
  
)

export default component.exports